module.exports = __webpack_public_path__ + "static/media/madrassa6.565cd4ca.webp";